var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.COMP_NAME = {
        'cli_inf': 'Client Information',
        'inc_sou': 'Income Sources',
        'inc_fro_ass': 'Income from Asserts',
        'inc_lif_rep': 'Income for life Report',
        'ris_gra': 'Risk Graph',
        'inv_rep': 'Investment Report',
        'dashboard': 'Dashboard',
        'company_config': 'Company Configuration',
        'expense': 'Expense',
        'revenue': 'Revenue',
        'marketing_production': 'MarketingProduction'
    };
    Constants.ALERT_TYPE = {
        'success': 'alert alert-success',
        'danger': 'alert alert-danger',
        'info': 'alert alert-info',
        'warning': 'alert alert-warning'
    };
    Constants.MODULE_TYPE = {
        HOME: 0,
        FP4FA: 1
    };
    Constants.LANDING_HEADER_OPTION = {
        isHamburger: false,
        isSearch: false,
        isNotification: false,
        isOtherMenu: false,
        isTopRightMenu: true
    };
    Constants.HOME_HEADER_OPTION = {
        isHamburger: true,
        isSearch: false,
        isNotification: false,
        isOtherMenu: false,
        isTopRightMenu: true
    };
    Constants.BISIQ_HEADER_OPTION = {
        isHamburger: true,
        isSearch: false,
        isNotification: false,
        isOtherMenu: false,
        isTopRightMenu: false
    };
    Constants.AUTHORIZATION = 'basic ZGluaXRoaWpAYXRsaW5rY29tLmNvbToxMjM=';
    Constants.LAST_YEAR = 100;
    Constants.DEFAULT_CHOICE_NAME = "New"; //"Default"
    Constants.CURRENT_CHOICE_NAME = "(Work)"; //"(Current)"
    Constants.REPORT_NAME = "Longevity Report";
    Constants.FTAOrganizationID = "e2671f9d-6c9f-11e9-856b-dc4a3ef770fd";
    Constants.REPORT_TYPE = {
        Rpt_Default: 'Rpt_Default',
        Rpt_ClientDies: 'Rpt_ClientDies',
        Rpt_SpouseDies: 'Rpt_SpouseDies'
    };
    Constants.TABLE_NAME = {
        Client: 'Client',
        Choice: 'Choice',
        IncomeSources: 'IncomeSources',
        IncomeFromAssets: 'IncomeFromAssets'
    };
    Constants.IncomeType = {
        IncomeSources: "IncomeSources",
        IncomeFromAssets: "IncomeFromAssets"
    };
    Constants.UserRoleID = {
        Admin: "1",
        User: "2",
        RIAOnly: "3"
    };
    Constants.Blend = {
        Blends: 0,
        MyBlends: 1
    };
    Constants.IndexBlend = {
        IndexBlends: 0,
        MyIndexBlends: 1
    };
    Constants.TickerBlend = {
        TickerBlends: 0,
        MyTickerBlends: 1
    };
    Constants.SavedReportType = {
        OldZephyr: "0",
        RiskGraph: "1",
        InvestmentReport: "2"
    };
    Constants.FieldError = {
        InvalidFieldDataType: "Invalid Date"
    };
    Constants.ExpenseCategories = {
        Advertising: "Advertising",
        Employees: "Employees",
        AdvisorPay: "Advisor Pay",
        PayrollTaxes: "Payroll Taxes",
        COLAIncrease: "COLA Increase ( Starting in Year 2)",
        StaffPerformanceBonusPool: "Staff Performance Bonus Pool",
        InsuranceBenefits: "Insurance Benefits",
        RetirementBenefits: "Retirement Benefits",
        Rent: "Rent",
        EAndOInsurance: "Errors and Omissions Insurance ",
        BusinessLiabilityInsurance: "Business Liability Insurance ",
        WorkersCompensationInsurance: "Worker’s Compensation Insurance ",
        OtherInsuranceCosts: "Other Insurance Costs",
        OtherExpenses: "Other Expenses"
    };
    Constants.Months = {
        Jan: "Jan",
        Feb: "Feb",
        Mar: "Mar",
        Apr: "Apr",
        May: "May",
        Jun: "Jun",
        Jul: "Jul",
        Aug: "Aug",
        Sep: "Sep",
        Oct: "Oct",
        Nov: "Nov",
        Dec: "Dec"
    };
    Constants.MarketingChannels = {
        Workshops: "51d1908e-dd68-11eb-b9d8-00ff28044310",
        RadioShows: "51d19af8-dd68-11eb-b9d8-00ff28044310",
        RadioSpots: "51d19b8a-dd68-11eb-b9d8-00ff28044310",
        TV: "51d19bb0-dd68-11eb-b9d8-00ff28044310"
    };
    return Constants;
}());
export { Constants };
//# sourceMappingURL=constants.js.map